'use strict';

var create = function create(type, isQueued, command, actionType) {
  return Object.assign({}, { type: type, isQueued: isQueued, command: command, actionType: actionType });
};

var createImmediateCmd = function createImmediateCmd(type, command, actionType) {
  return create(type, false, command, actionType);
};

var createQueuedCmd = function createQueuedCmd(type, command, actionType) {
  return create(type, true, command, actionType);
};

var isCommand = function isCommand(maybeCommand) {
  return maybeCommand != null && typeof maybeCommand.isQueued === 'boolean' && typeof maybeCommand.type === 'string';
};

var isImmediateCommand = function isImmediateCommand(maybeCommand) {
  return isCommand(maybeCommand) && !maybeCommand.isQueued;
};

var isQueuedCommand = function isQueuedCommand(maybeCommand) {
  return isCommand(maybeCommand) && maybeCommand.isQueued;
};

module.exports = {
  createImmediateCmd: createImmediateCmd,
  createQueuedCmd: createQueuedCmd,
  isCommand: isCommand,
  isImmediateCommand: isImmediateCommand,
  isQueuedCommand: isQueuedCommand
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/commands.js
// module id = 101
// module chunks = 0